import { useDispatch, useSelector } from "react-redux";

import QuantityInput from "./QuantityInput/QuantityInput";
import DiscountSelector from "./DiscountSelector/DiscountSelector";

import { RootState } from "@/store/store";
import { setToggleServiceDrawer } from "@/store/ui/ui";
import priceFormatter from "@/utils/priceFormatter";

import {
    updateNewAppointment,
    updateServicePriceToNewAppointment,
    updateServicePriceToExistAppointment,
    updateExistAppointment,
} from "@/store/appointments/appointmentsSlice";

import "./AppointmentsServisesList.scss";
import Title from "@/shared/components/Title/Title";
import { toast } from "react-toastify";
import { visitMessage } from "@/utils/constants";

export default function AppointmentsServicesList() {
    const dispatch = useDispatch();
    const isEditAppointment = useSelector(
        (state: RootState) => state.ui.isEditAppointment,
    );
    const services = useSelector((state: RootState) =>
        isEditAppointment
            ? state.appointments.existtAppointment.services
            : state.appointments.newAppointment.services,
    );
    const isAppointmentComplete = useSelector(
        (state: RootState) =>
            state.appointments.existtAppointment.isAppointmentComplete,
    );

    function openServiceDrawer() {
        if (!isAppointmentComplete) {
            dispatch(setToggleServiceDrawer(true));
        } else toast.error(visitMessage);
    }

    function updateServicesList(newServices: typeof services) {
        const action = isEditAppointment
            ? updateExistAppointment({ services: newServices })
            : updateNewAppointment({ services: newServices });
        dispatch(action);
    }

    function deleteService(id: string) {
        if (!isAppointmentComplete) {
            const filtered = services.filter(item => item._id !== id);
            updateServicesList(filtered);
        } else toast.error(visitMessage);
    }
    function inputHandleChange(
        e: React.ChangeEvent<HTMLInputElement>,
        serviceId: string,
    ) {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            const action = isEditAppointment
                ? updateServicePriceToExistAppointment
                : updateServicePriceToNewAppointment;
            dispatch(action({ id: serviceId, price: value }));
        }
    }

    return (
        <div className='appointments_servise_list_container'>
            <Title tag='h3' text={"Послуги"} />
            <button
                className='appointments_servise_list_button_add_service'
                onClick={openServiceDrawer}
            >
                <img src='/appointmenspage/button-add.svg' alt='logo plus' />
                Додати послугу
            </button>
            <ul className='appointments_services_listing'>
                {services.map(item => (
                    <li className='appointments_service_item' key={item._id}>
                        <div className='service_item_title_container service_item'>
                            <p className='service_item_title'>{item.title}</p>
                            {item.description !== "0" ? (
                                <p className='service_item_description'>
                                    {item.description}
                                </p>
                            ) : null}
                        </div>
                        {item.description !== "0" ? (
                            <>
                                <QuantityInput
                                    id={item._id}
                                    quantity={item.quantity}
                                    isEditAppointment={isEditAppointment}
                                    isAppointmentComplete={
                                        isAppointmentComplete
                                    }
                                />
                                <DiscountSelector
                                    id={item._id}
                                    discount={item.discount}
                                    isEditAppointment={isEditAppointment}
                                    isAppointmentComplete={
                                        isAppointmentComplete
                                    }
                                />
                                <input
                                    className='service_item_price service_item_price_input  service_item'
                                    placeholder='0'
                                    type='text'
                                    maxLength={6}
                                    value={+item.price > 0 ? item.price : ""}
                                    onChange={e =>
                                        inputHandleChange(e, item._id)
                                    }
                                />
                            </>
                        ) : (
                            <>
                                <QuantityInput
                                    id={item._id}
                                    quantity={item.quantity}
                                    isEditAppointment={isEditAppointment}
                                    isAppointmentComplete={
                                        isAppointmentComplete
                                    }
                                />
                                <DiscountSelector
                                    id={item._id}
                                    discount={item.discount}
                                    isEditAppointment={isEditAppointment}
                                    isAppointmentComplete={
                                        isAppointmentComplete
                                    }
                                />
                                <p className='service_item_price service_item_price_paragraf service_item'>
                                    {priceFormatter(item.price)}
                                </p>
                            </>
                        )}

                        <button
                            onClick={() => deleteService(item._id)}
                            className='service_item_delete'
                            id={item._id}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
}
